module.exports = __webpack_public_path__ + "img/3.c43529d3.png";